import { I18n } from "@assets/strings";
import { Path } from "@core/routing/path";
import { useHistory } from "@core/routing/useHistory";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useMySharerooms } from "@domain/group/hooks";
import { usePostCreation } from "@domain/post/hooks";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { EditIcon } from "@ui/components/icons";
import { Row } from "@ui/components/layout";
import { LinkExternal } from "@ui/components/linkExternal";
import { Page } from "@ui/components/page";
import { CreatePostInput } from "@ui/components/post/createPostInput";
import { FeedList } from "@ui/components/post/feedList";
import { useIsMobile } from "@utils/hooks";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import styled, { css } from "styled-components";
// import { PostModal } from "../../components/post/postModal";
import { config } from "@core/config/config";
import { GroupsModal } from "@ui/components/group/groupsModal";
import { useCompleteProfilePrompt } from "@ui/components/profile/useCompleteProfilePrompt";
import { SliderPub } from "@ui/components/pub/sliderPub";
import { QuizModal } from "@ui/components/quiz/quizModal";
import { StickyColumn } from "@ui/components/stickyColumn";
import { useModalTools } from "@ui/modals/modalContext";
import { moreInfos } from "@ui/pages/more/moreInfos";
import { GroupList } from "@ui/pages/profilePage/groupList";
import { ProfileCard } from "@ui/pages/profilePage/profileCard";
import { alpha, gap, mobileOnly } from "@ui/styles/utils";
import { Z } from "@ui/styles/zIndex";
import { CourseSuggestCard } from "../homePage/courseSuggestCard";
import { ArticleSuggestCard } from "./articleSuggestCard";
import { NewContentIncentive } from "./newContentIncentive";
import { ProfileSuggestions } from "./profileSuggestions";

type HomePageProps = React.HTMLAttributes<HTMLDivElement>;
export const HomePage: React.FC<HomePageProps> = ({ ...htmlProps }) => {
	const currentProfile = useCurrentProfile();
	const { totalElements: totalSharerooms, result: sharerooms, loading: shareroomsLoading } = useMySharerooms();
	const [postButtonVisible, setPostButtonVisible] = useState(false);
	const { createModal, activeModalsCount } = useModalTools();
	const history = useHistory();
	const location = useLocation();
	const isMobile = useIsMobile();
	const [currentYear, setCurrentYear] = useState<Date>(new Date());
	useCompleteProfilePrompt();

	useEffect(() => {
		const { quiz, source } = queryString.parse(location.search);
		setCurrentYear(new Date());
		const goHome = (): void => history.push(Path.Root);
		// const goToPostPage = (post: string): void => history.push(Path.Post(post, true));
		// const pubImage=getBannerPub()
		// setPubImage(getBannerPub())
		// if (post && typeof post === "string") {
		// 	if (!isMobile) {
		// 		createModal(
		// 			(close) => (
		// 				<PostModal
		// 					postId={post}
		// 					close={() => {
		// 						close();
		// 						goHome();
		// 					}}
		// 				/>
		// 			),
		// 			{
		// 				onBackdropClick: goHome,
		// 			}
		// 		);
		// 	} else {
		// 		goToPostPage(post);
		// 	}
		// } else
		if (quiz && typeof quiz === "string") {
			createModal((close) => (
				<QuizModal
					quizId={quiz}
					source={source as string | undefined}
					close={() => {
						close();
						goHome();
					}}
				/>
			));
		}
	}, [location.search]);

	const createPost = usePostCreation();

	if (!currentProfile) {
		return null;
	}

	return (
		<Container {...htmlProps} onScrollStarted={setPostButtonVisible}>
			{/* <HelmetInfos title={I18n.t("seo.auth.title")} ogTitle={I18n.t("og_title")} /> */}
			{/* <Seo
				title={I18n.t("seo.auth.title")}
				description={I18n.t("og_title")}
				type="website"
				ogImage={require("../../../assets/images/tooshare.jpg")}
				canonicalLink={`${Config.APP_BASE_URL}${location.pathname}`}
			/> */}
			<StyledLeft topOffset={130} bottomOffset={20}>
				<ProfileCard profile={currentProfile} hideDetails />
				{totalSharerooms !== undefined && totalSharerooms !== 0 && (
					<Sharerooms>
						<Row gap={10} align="center" justify="space-between">
							<PrimaryMedium>{I18n.t("profile.menu.sharerooms")}</PrimaryMedium>
							<SeeMore>
								<span
									onClick={() =>
										createModal((close) => (
											<GroupsModal close={close} groups={sharerooms} loading={shareroomsLoading} type={"SHAREROOM"} />
										))
									}
								>
									{I18n.t("see_all")}
								</span>
							</SeeMore>
						</Row>
						<GroupList isMe size={3} gap={10} small isOnSide />
					</Sharerooms>
				)}

				{/* <TestersFeedback >
					<LinkExternal to={I18n.t("home.test_feedback.button.url")}>
						<img src={require("../../../assets/images/feedback_link.png")} />
					</LinkExternal>
				</TestersFeedback> */}

				<More>
					{moreInfos.map(({ page, pathname }) => (
						<span key={page}>
							{page !== "support" ? (
								<LinkExternal to={pathname}>{I18n.t(`more.page.${page}`).replace(/ /g, " ")} - </LinkExternal>
							) : (
								<a href={`mailto:${pathname}`}>{`${I18n.t(`more.page.${page}`)} - `}</a>
							)}
						</span>
					))}
					<b>{I18n.t("more.copyright", { currentYear: currentYear.getFullYear() })}</b>
				</More>
			</StyledLeft>
			<Header>{I18n.t("home.header", { name: currentProfile.primaryName })}</Header>
			<CreatePostInput />
			<Feed isFeed />
			<Suggestions topOffset={130} bottomOffset={20}>
				{config.features.banner && <SliderPub />}
				<CourseSuggestCard />
				<ArticleSuggestCard />
				<ProfileSuggestions />
			</Suggestions>
			{isMobile && activeModalsCount === 0 && (
				<MobileCreatePostButton visible={postButtonVisible} onClick={() => createPost()}>
					<EditIcon />
				</MobileCreatePostButton>
			)}
			<NewContentIncentive />
		</Container>
	);
};

const Container = styled(Page)`
	display: grid;
	grid-template-columns: 280px minmax(0, 1fr) 280px;
	grid-template-rows: auto;
	grid-column-gap: 20px;
	grid-row-gap: 24px;
	grid-template-areas:
		"profile header suggestions"
		"profile input suggestions"
		"profile input suggestions"
		"profile feed suggestions"
		"profile feed ."
		". feed ."
		". feed ."
		". feed ."
		". feed ."
		". feed .";

	@media (max-width: 900px) {
		grid-template-columns: 100%;

		grid-template-areas:
			"input"
			"feed";
	}
`;

const Suggestions = styled(StickyColumn)`
	grid-area: suggestions;
	${gap(24)};
	@media (max-width: 900px) {
		display: none;
	}
`;

const Header = styled.div`
	@media (max-width: 900px) {
		display: none;
	}
	grid-area: header;
	${({ theme }) => theme.textStyles.title};
`;

const Feed = styled(FeedList)`
	grid-area: feed;
`;

const MobileCreatePostButton = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "visible",
})<{ visible: boolean }>`
	${mobileOnly("flex")};
	display: flex;
	pointer-events: none;
	opacity: 0;
	position: fixed;
	bottom: 28px;
	right: 20px;
	justify-content: center;
	align-items: center;
	width: 50px;
	height: 50px;
	border-radius: 25px;
	background-color: ${({ theme }) => theme.colors.primary};
	box-shadow: 0 2px 14px 0 ${({ theme }) => alpha(theme.colors.primary, 0.6)};
	z-index: ${Z.menu};

	${({ visible }) =>
		visible
			? css`
					opacity: 1;
					pointer-events: auto;
				`
			: css`
					opacity: 0;
					pointer-events: none;
				`}

	transition: opacity 0.2s ease-in;

	svg {
		width: 27px;
		height: 26px;
		path {
			fill: ${({ theme }) => theme.colors.white};
		}
	}
`;

const StyledLeft = styled(StickyColumn)`
	@media (max-width: 900px) {
		display: none;
	}
	position: sticky;
	grid-area: profile;
	${gap(20)};
`;

/*const TestersFeedback = styled.div`
	background-color: ${({ theme }) => theme.colors.lightergray};
	border-radius: 12px;
	min-height: 210px;
	max-height: 210px;
	overflow: hidden;
	margin-top: 40px;

	img {
		width: 100%;
		border-radius: 10px;
	}
`;*/

const More = styled.div`
	${({ theme }) => theme.textStyles.lighter};
`;

const Sharerooms = styled.div`
	${gap(15)};
`;

const SeeMore = styled.div`
	${({ theme }) => theme.textStyles.text};
	flex: 1 0 auto;
	text-align: end;
	color: ${({ theme }) => theme.colors.secondary};
	> span {
		cursor: pointer;
	}
`;
